var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import cx from 'classnames';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import ProductServicesTooltip from 'components/ProductServicesTooltip/ProductServicesTooltip';
import StringWidget, { stringTemplate } from 'components/StringWidget/StringWidget';
import RadioList from 'components/Radio/RadioList';
import { ExclamationIcon } from 'components/Icons/Icons';
import { ChildItems, CHILD_ITEM_TYPE_LIST } from 'components/CartItem/ChildItems';
import CartBuyBack from 'components/CartBuyBack/CartBuyBack';
import Timer from 'components/Timer/Timer';
import OpenBoxDeliveryWidget from './OpenBoxDelivery/OpenBoxDeliveryWidget';
import { SERVICE_TYPES } from 'constants/CheckoutConstants';
import { isEmpty } from 'lodash';
import { get } from 'lodash';
import SimpleImage from 'components/Common/Image/SimpleImage';
import shallowEqual from 'utils/shallowEqual';
import fkAdvantageLogo from 'images/fa.png';
import timer from 'images/timer-asm.svg';
import refershIcon from 'images/refresh-blue.svg';
import SLAItem from 'components/CartItem/SLAItem/SLAItem';
import CartOffer from './CartOffer/CartOffer';
import CartActions from './CartActionButton/CartActions';
import CartQuantityWidget from './CartQuantityWidget/CartQuantityWidget';
import PreBookPriceInfo from './PreBookPriceInfo';
import styles from './CartItem.css';
import StaticPage from '../../pages/Checkout/StaticPage';
import { trackCancellationLinkClick } from '../../pages/Checkout/CheckoutPageAnalytics';
import { CartItemState } from '@rome/response/cart/enums/CartItemState';
import { ASMDisplayState } from '@rome/response/common/enums/ASMDisplayState';
import { trackRemoveChildItem } from 'pages/CartPage/CartPageAnalytics';
import { getItemState, getCartReferenceId } from 'utils/cartUtils';
import { CartItemCardPriceInfo } from './CartItemCardPriceInfo';
import * as PlusPrice from 'components/PriceWidget/PlusPrice';
import { numFormat } from 'utils/numFormat';
import { EffectType, SimpleMinimumOrderQuantity } from 'components/MinimumOrderQuantity/MinimumOrderQuantity';
export var CartItemParent;
(function (CartItemParent) {
    CartItemParent["CART"] = "CART";
    CartItemParent["CHECKOUT"] = "CHECKOUT";
})(CartItemParent || (CartItemParent = {}));
function LinkMaybe(props) {
    const { parent, to } = props, rest = __rest(props, ["parent", "to"]);
    if (parent === CartItemParent.CART) {
        return <Link to={to} {...rest}/>;
    }
    return <div {...rest}/>;
}
export default class CartItem extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            asmTimerExpiry: false,
            isTooltipOmnitureHandled: false
        };
        this.handleOBDSelection = (obdSelected = false) => {
            const { parent, cartItem, changeQuantity } = this.props;
            if (typeof changeQuantity === 'function') {
                changeQuantity({
                    cartItemRefId: getCartReferenceId(parent, cartItem),
                    obdSelected
                }, SERVICE_TYPES.CHANGE_OBD_RECOMMENDATION);
            }
        };
        this.handleQuantityChange = (newQuantity) => {
            const { parent, cartItem, changeQuantity } = this.props;
            let quantity = cartItem.quantity;
            let quantityStr = '';
            // TODO: This is tied up to the cart quantity component.
            if (typeof quantity !== 'undefined') {
                quantityStr = quantity.toString();
            }
            if (newQuantity !== quantityStr && typeof changeQuantity === 'function') {
                changeQuantity({
                    cartItemRefId: getCartReferenceId(parent, cartItem),
                    quantity: newQuantity
                });
            }
        };
        /* Only used in checkout */
        this.handleDeliveryPromiseChange = serviceValue => {
            let { cartItem, changeDeliveryPromise } = this.props;
            if (isEmpty(cartItem))
                return null;
            cartItem = cartItem;
            const { cartItemRefId } = cartItem;
            if (typeof changeDeliveryPromise === 'function')
                changeDeliveryPromise(cartItemRefId, serviceValue);
        };
        // TODO: No need to have this, just pass the function directly
        this.handleAddCartItem = (listing, mainProductListingId) => {
            const { addCartItem } = this.props;
            if (typeof addCartItem === 'function') {
                addCartItem(listing, mainProductListingId);
            }
        };
        this.handleRemoveChildItem = (listingId, childItemType) => {
            const { parent } = this.props;
            if (parent === CartItemParent.CHECKOUT) {
                this.context.modal.show({
                    children: this.renderItemRemoveConfirmationModal(listingId, childItemType),
                    classNames: {
                        dialog: styles['user-confirmation-popup']
                    },
                    closeOnOverlayClick: true,
                    closeButton: true
                });
            }
        };
        /* only used in ASM */
        this.handleAsmCartExpiry = () => {
            const { onASMCartExpiry } = this.props;
            this.setState({ asmTimerExpiry: true }, () => {
                if (typeof onASMCartExpiry === 'function') {
                    onASMCartExpiry();
                }
            });
        };
        this.handleAsmCheckoutExpiry = () => {
            const { onASMCheckoutExpiry } = this.props;
            this.setState({ asmTimerExpiry: true }, () => {
                if (typeof onASMCheckoutExpiry === 'function') {
                    onASMCheckoutExpiry();
                }
            });
        };
        this.handleASMCartExpiryClick = () => {
            const { onASMRecheckAvailability } = this.props;
            if (typeof onASMRecheckAvailability === 'function') {
                onASMRecheckAvailability();
            }
        };
        this.handleLinkTextClick = () => {
            const { handleLinkTextClick } = this.props;
            handleLinkTextClick && handleLinkTextClick();
        };
        this.closeItemRemoveConfirmationModal = () => {
            this.context.modal.hide();
        };
        this.removeChildItem = (listingId) => {
            const { moveItemToCart, cartItem } = this.props;
            this.closeItemRemoveConfirmationModal();
            if (typeof moveItemToCart === 'function') {
                moveItemToCart(listingId).then(_ => {
                    trackRemoveChildItem(cartItem, listingId);
                });
            }
        };
        this.renderItemRemoveConfirmationModal = (listingId, childItemType) => {
            return (<React.Fragment>
				<div className={styles['title']}>
					{childItemType === CHILD_ITEM_TYPE_LIST.SAAL
                ? stringTemplate('removeSAALItem')
                : stringTemplate('removeItem')}
				</div>
				<div className={styles['subtitle']}>
					{childItemType === CHILD_ITEM_TYPE_LIST.SAAL
                ? stringTemplate('removeSAALConfirmation')
                : stringTemplate('removeConfirmation')}
				</div>

				<div className={cx('row', styles['buttons-container'])}>
					<div className={cx(styles['button'], styles['secondary'])} onClick={this.closeItemRemoveConfirmationModal}>
						{childItemType === CHILD_ITEM_TYPE_LIST.SAAL
                ? stringTemplate('removeSAALCancelButtonText')
                : stringTemplate('cancel')}
					</div>

					<div className={cx(styles['button'], styles['primary'])} onClick={() => this.removeChildItem(listingId)}>
						{childItemType === CHILD_ITEM_TYPE_LIST.SAAL
                ? stringTemplate('removeSAALOkButtonText')
                : stringTemplate('removeText')}
					</div>
				</div>
			</React.Fragment>);
        };
        this.renderPriceDetails = () => {
            let { parent, cartItem } = this.props;
            if (isEmpty(cartItem))
                return null;
            cartItem = cartItem;
            const { pricingInfo, reservationDetails, cardPricingDetails } = cartItem;
            const preBookInfo = get(cartItem, 'preBookInfo');
            const itemState = getItemState(parent, cartItem);
            const asmDisplayState = get(reservationDetails, 'asmDisplayState');
            if (pricingInfo && itemState === CartItemState.BUYABLE) {
                return (<React.Fragment>
					<PlusPrice.Applied cartItem={cartItem}/>
					<CartItemCardPriceInfo details={cardPricingDetails} isEmphasized={!!preBookInfo}/>
					<CartOffer cartItem={cartItem} showOnlyInfoIcon={!!preBookInfo} isV4Context={false}/>
					<PlusPrice.Applicable cartItem={cartItem}/>
					<PreBookPriceInfo preBookInfo={preBookInfo}/>
				</React.Fragment>);
            }
            else if (itemState === CartItemState.COLD_STATE) {
                if (asmDisplayState === ASMDisplayState.WAITLIST_AVAILABLE) {
                    return <StringWidget strKey="cartWaitlistAvailable" className={styles['out-of-stock']}/>;
                }
                else if (asmDisplayState === ASMDisplayState.WAITLIST_FULL) {
                    return <StringWidget strKey="cartWaitlistFull" className={styles['out-of-stock']}/>;
                }
                else if (asmDisplayState === ASMDisplayState.WAITLIST_ALLOTTED) {
                    return <StringWidget strKey="cartWaitlistAllotted" className={styles['out-of-stock']}/>;
                }
                else if (asmDisplayState === ASMDisplayState.RESERVABLE) {
                    return null;
                }
                return <StringWidget strKey="cartOutOfStock" className={styles['out-of-stock']}/>;
            }
            return null;
        };
        this.renderSeller = () => {
            let { parent, cartItem } = this.props;
            if (isEmpty(cartItem))
                return null;
            cartItem = cartItem;
            const { sellerName, flipkartAssured } = cartItem;
            const itemState = getItemState(parent, cartItem);
            if (itemState === CartItemState.BUYABLE) {
                return (<div className={styles['cart-item-seller']}>
					<StringWidget strKey="cartSeller" attributes={{ sellerName }}/>
					{flipkartAssured === true && <img className={styles['fadvantage']} src={fkAdvantageLogo}/>}
				</div>);
            }
            return null;
        };
        this.renderSubtitle = () => {
            let { parent, cartItem } = this.props;
            if (isEmpty(cartItem))
                return null;
            cartItem = cartItem;
            const { coSubTitle, subTitle } = cartItem;
            const itemState = getItemState(parent, cartItem);
            if (itemState === CartItemState.BUYABLE && (coSubTitle || subTitle)) {
                const subtitle = [coSubTitle || '', subTitle || ''].filter(x => x).join(',');
                return <div className={styles['cart-item-subtitle']}> {subtitle} </div>;
            }
            return null;
        };
        this.renderQuantityWidget = () => {
            let { parent, cartItem } = this.props;
            if (isEmpty(cartItem))
                return null;
            cartItem = cartItem;
            const { quantity, quantityMetaData = {} } = cartItem;
            const minQuantity = quantityMetaData.minQuantity || 1;
            const restrictQuantityUpdate = quantityMetaData.restrictQuantityUpdate;
            const itemState = getItemState(parent, cartItem);
            const quantityStr = typeof quantity === 'number' || typeof quantity === 'string' ? quantity.toString() : '';
            if (itemState === CartItemState.BUYABLE) {
                return (<CartQuantityWidget {...{ quantity: quantityStr, minQuantity, handleQuantityChange: this.handleQuantityChange }} disabled={restrictQuantityUpdate}/>);
            }
            return null;
        };
        this.renderTimer = () => {
            const { parent } = this.props;
            let { cartItem, timeStamp } = this.props;
            if (isEmpty(cartItem) || isEmpty(cartItem.reservationDetails))
                return null;
            // The timeStamp check was not present before, but since we are doing a
            // subtraction below, it's best to check this. However, need to verify
            // if we have to return null in that case, or may be default it to
            // something else
            timeStamp = typeof timeStamp === 'undefined' ? 0 : timeStamp;
            cartItem = cartItem;
            let reservationDetails = cartItem.reservationDetails;
            const { asmTimerExpiry } = this.state;
            const { ttl, presentTs, asmDisplayState } = reservationDetails;
            if (typeof ttl !== 'number' || !presentTs)
                return null;
            const handleExpiry = parent === CartItemParent.CART
                ? this.handleAsmCartExpiry
                : parent === CartItemParent.CHECKOUT
                    ? this.handleAsmCheckoutExpiry
                    : () => null;
            const itemState = getItemState(parent, cartItem);
            const showTimedOut = itemState === CartItemState.COLD_STATE && asmDisplayState === ASMDisplayState.RESERVABLE;
            // see docs/timer-logic.md for explanation
            // T2 - C + C1 - T1
            const timeRemaining = ttl - new Date().getTime() + timeStamp - presentTs;
            return (<div className={cx(styles['timer'], { [styles['expired']]: asmTimerExpiry || showTimedOut })}>
				<div className={styles['timer-row']}>
					<div className={styles['main-text']}>
						{asmTimerExpiry ? stringTemplate('asmCartItemTimedOut') : stringTemplate('asmCartItemTimmerRunning')}
					</div>
					<div className={styles['timer-text']}>
						<img src={timer} className={styles['timer-img']}/>
						{showTimedOut ? (stringTemplate('asmCartTimedOut')) : (<Timer key={presentTs} timeRemaining={timeRemaining} onExpiry={handleExpiry}/>)}
					</div>
				</div>
				{parent === CartItemParent.CART && (this.state.asmTimerExpiry || showTimedOut) && (<div className={styles['timer-recheck']} onClick={this.handleASMCartExpiryClick}>
						<img src={refershIcon} className={styles['refresh-icon']}/>
						<span>{stringTemplate('asmCartRecheckAvailability')}</span>
					</div>)}
			</div>);
        };
        this.renderSLAs = () => {
            let { cartItem, pincode, onTimerExpiry } = this.props;
            const { deliverySla, serviceable, deliveryInfo } = cartItem;
            if (deliverySla) {
                return (<ul className={styles['cart-sla-list']}>
					{deliverySla.map((sla, index) => {
                    const { urgency, prices, slaMessageConstruct } = sla;
                    return (<li className={styles['cart-sla-entry']} key={index}>
								<SLAItem onTimerExpiry={onTimerExpiry} key={index} slaMessageConstruct={slaMessageConstruct} serviceable={serviceable} pincode={pincode} prices={prices} urgency={urgency}/>
							</li>);
                })}
				</ul>);
            }
            else if (deliveryInfo) {
                const slaStatus = get(deliveryInfo, ['slaText', 'status']);
                const slaText = get(deliveryInfo, ['slaText', 'text']);
                return (<React.Fragment>
					{slaStatus === 'info' && (<div className={cx(styles['cart-item-sla'], { [styles['error']]: !serviceable })}>{slaText}</div>)}
					{slaStatus === 'warning' && !serviceable && pincode && (<div className={styles['cold-state-info']}>
							<ExclamationIcon className={styles['cold-state-info-icon']}/>
							<span className={styles['cold-state-info-text']}>{slaText}</span>
						</div>)}
				</React.Fragment>);
            }
            return null;
        };
        this.showCancellationPolicy = item => () => {
            trackCancellationLinkClick(item);
            this.context.modal.show({
                children: <StaticPage pageId="cancellation-tnc"/>,
                classNames: {
                    dialog: styles['cancellation-policy-dialog']
                },
                closeButton: true,
                closeOnOverlayClick: true
            });
        };
        this.renderDeliveryInfo = () => {
            const { allOOS, obdMetaData, parent, pincode, onTimerExpiry } = this.props;
            let { cartItem } = this.props;
            if (isEmpty(cartItem))
                return null;
            cartItem = cartItem;
            const { pricingInfo, deliveryInfo, deliverySla, serviceable, forwardServices, reverseServices, listingId, reservationDetails, productUrl } = cartItem;
            const { itemState: serviceableState } = cartItem;
            const itemState = getItemState(parent, cartItem);
            const asmDisplayState = get(reservationDetails, ['asmDisplayState']);
            const replacementPolicy = Array.isArray(reverseServices) && reverseServices.filter(service => service.tabType === 'REPLACEMENT')[0];
            const slaText = get(deliveryInfo, ['slaText', 'text']);
            const renderDeliveryMarkup = promiseInfo => {
                if (isEmpty(promiseInfo))
                    return null;
                const { prices, slaMessageConstruct, urgency, slaMessage } = promiseInfo;
                if (!slaMessageConstruct) {
                    return null;
                }
                const { text } = slaMessageConstruct;
                if ((!serviceable && parent === CartItemParent.CART) ||
                    (parent === CartItemParent.CHECKOUT && serviceableState === 'NON_SERVICEABLE')) {
                    return text || slaText;
                }
                if (slaMessageConstruct) {
                    return (<SLAItem onTimerExpiry={onTimerExpiry} slaMessageConstruct={slaMessageConstruct} serviceable={true} pincode={pincode} prices={prices} urgency={urgency}/>);
                }
                return slaMessage ? slaMessage : null;
            };
            const renderPickupCharge = pickUpCharge => {
                if (pickUpCharge > 0) {
                    return (<li>
						<StringWidget strKey="cartPickupCharge" attributes={{ pickupCharge: `₹${numFormat(Number(pickUpCharge))}` }}/>
					</li>);
                }
                return null;
            };
            const renderForwardServices = forwardServices => {
                if (forwardServices) {
                    return forwardServices.map(service => <li key={service}>{service}</li>);
                }
                return null;
            };
            if (itemState === CartItemState.BUYABLE && parent === CartItemParent.CART) {
                const { pickUpCharge } = pricingInfo || { pickUpCharge: 0 };
                // TODO: Rome models have different structure compared to the existing usecase,
                // so adding a hack
                const replacementPolicyCount = get(replacementPolicy, 'count', 0);
                return (<div className={styles['cart-item-delivery-info']}>
					{this.renderTimer()}
					{this.renderSLAs()}
					<ul className={styles['delivery-more-info']}>
						{!deliverySla && deliveryInfo && deliveryInfo.slotsAvailable && (<li>
								<StringWidget strKey="cartDeliverySlot"/>
							</li>)}
						{renderPickupCharge(pickUpCharge)}
						{!deliverySla && get(deliveryInfo, ['fasterOptionsAvailable']) && (<li>
								<StringWidget strKey="fasterOptionsAvailable"/>
							</li>)}
						{renderForwardServices(forwardServices)}
						{replacementPolicyCount ? (<li className={styles['replacement-policy']}>
								<StringWidget strKey="servicesReplacementPolicy" attributes={{ numberOfDays: replacementPolicyCount }}/>
								<ProductServicesTooltip item={replacementPolicy} className={styles['replacement-tooltip']}/>
							</li>) : null}
					</ul>
				</div>);
            }
            else if (itemState === CartItemState.BUYABLE && parent === CartItemParent.CHECKOUT) {
                const { itemPromiseInfo, itemAnnouncements = [], obdRecommendation } = cartItem;
                const cancellationMessaging = itemAnnouncements.find(({ type }) => type === 'cancellationFeeAnnouncement');
                const { availablePromises = [], selectedPromiseSpeedType = '', isSlottedDeliveryAvailable = false } = itemPromiseInfo;
                const { pricingInfo } = cartItem;
                const pickUpCharge = get(pricingInfo, 'pickUpCharge');
                const forwardServices = cartItem.forwardServices;
                if (this.props.isEGV) {
                    return null;
                }
                return (<div className={styles['cart-item-delivery-info']}>
					{this.renderTimer()}
					<div className={styles['cart-item-sla']}>
						{availablePromises.length >= 2 ? (<RadioList checkedId={selectedPromiseSpeedType} name={`${listingId}-promises`} onChange={this.handleDeliveryPromiseChange}>
								{availablePromises.map(promise => {
                    return (<span key={promise.type} className={styles['sla']}>
											{renderDeliveryMarkup(promise)}
										</span>);
                })}
							</RadioList>) : (renderDeliveryMarkup(availablePromises[0]))}
					</div>
					<div className={styles['delivery-more-info']}>
						{cancellationMessaging ? (<div className={styles['cancellation-messaging']}>
								<div>
									{cancellationMessaging.prefix ? (<span className={styles['prefix']}>{cancellationMessaging.prefix}</span>) : null}
									<span>{cancellationMessaging.message}</span>
								</div>
								{cancellationMessaging.linkText ? (<a className={styles['link']} href="#" onClick={this.showCancellationPolicy(cartItem)}>
										{cancellationMessaging.linkText}
									</a>) : null}
							</div>) : null}
						<OpenBoxDeliveryWidget itemForTracking={cartItem} value={obdRecommendation} data={obdMetaData} onSelection={this.handleOBDSelection}/>
						{isSlottedDeliveryAvailable ? (<StringWidget strKey="cartDeliverySlot" className={styles['delivery-slot']}/>) : null}
						{renderPickupCharge(pickUpCharge)}
						{renderForwardServices(forwardServices)}
					</div>
				</div>);
            }
            else if (itemState === CartItemState.COLD_STATE) {
                if (asmDisplayState === ASMDisplayState.WAITLIST_AVAILABLE) {
                    const link = (<LinkMaybe to={productUrl || '/'} parent={parent} className={styles['link']}>
						here
					</LinkMaybe>);
                    return (<div className={styles['cold-state-info']}>
						<ExclamationIcon className={styles['cold-state-info-icon']}/>
						<StringWidget strKey="asmCartWaitlistInfo" className={styles['cold-state-info-text']} attributes={{ link }}/>
					</div>);
                }
                else if (asmDisplayState === ASMDisplayState.WAITLIST_ALLOTTED) {
                    const link = (<LinkMaybe to={productUrl || '/'} parent={parent} className={styles['link']}>
						item
					</LinkMaybe>);
                    return (<div className={styles['cold-state-info']}>
						<ExclamationIcon className={styles['cold-state-info-icon']}/>
						<StringWidget strKey="asmCartWaitlistAllottedInfo" className={styles['cold-state-info-text']} attributes={{ link }}/>
					</div>);
                }
                else if (asmDisplayState === ASMDisplayState.RESERVABLE) {
                    return this.renderTimer();
                }
                else if (!allOOS) {
                    return (<div className={styles['cold-state-info']}>
						<ExclamationIcon className={styles['cold-state-info-icon']}/>
						<StringWidget strKey="cartColdStateInfo" className={styles['cold-state-info-text']}/>
					</div>);
                }
                return null;
            }
            return null;
        };
        this.renderNbfcOfferInfo = () => {
            let { parent, cartItem } = this.props;
            if (isEmpty(cartItem))
                return null;
            cartItem = cartItem;
            const { nbfcOffers } = cartItem;
            const itemState = getItemState(parent, cartItem);
            if (itemState === CartItemState.BUYABLE && nbfcOffers && nbfcOffers.warning) {
                return <div className={styles['cart-item-nbfc']}>{nbfcOffers.warning}</div>;
            }
            return null;
        };
        this.renderMinimumOrderQuantity = () => {
            let { parent, cartItem } = this.props;
            if (isEmpty(cartItem))
                return null;
            cartItem = cartItem;
            const itemState = getItemState(parent, cartItem);
            if (itemState === CartItemState.BUYABLE) {
                const { itemAnnouncements } = cartItem;
                if (itemAnnouncements && itemAnnouncements.length > 0) {
                    const moqAnnouncement = itemAnnouncements.filter(announcement => announcement.type === 'moqAnnouncement')[0];
                    return moqAnnouncement ? (<SimpleMinimumOrderQuantity message={moqAnnouncement.message} linkText={moqAnnouncement.linkText} className={styles['min-quantity']} effectType={EffectType.HIGHLIGHT} handleLinkTextClick={this.handleLinkTextClick}/>) : null;
                }
                return null;
            }
            return null;
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const oldReservationDetails = get(this.props, 'cartItem.reservationDetails');
        const newReservationDetails = get(nextProps, 'cartItem.reservationDetails');
        if (!shallowEqual(oldReservationDetails, newReservationDetails) && this.state.asmTimerExpiry) {
            this.setState({ asmTimerExpiry: false });
        }
    }
    shouldComponentUpdate(nextProps, nextState) {
        return !shallowEqual(this.props, nextProps) || this.state.asmTimerExpiry !== nextState.asmTimerExpiry;
    }
    render() {
        let { parent, cartItem, isEGV } = this.props;
        if (isEmpty(cartItem))
            return null;
        cartItem = cartItem;
        const { mainTitle, serviceable, productUrl, imageUrl, listingId, reservationDetails, restrictQuantityUpdate } = cartItem;
        const itemState = getItemState(parent, cartItem);
        const asmDisplayState = get(reservationDetails, ['asmDisplayState']);
        // During the APEX changes, it was decided to not show the cart item
        // quantity incr/decr widget. And that check right now is based on the
        // presence of any kind of child items (extended warranty or buyback
        // item etc.)
        const showQuantityWidget = !restrictQuantityUpdate; //!hasChildItems(cartItem);
        const isImageGrayScale = (itemState === CartItemState.COLD_STATE || serviceable === false) &&
            asmDisplayState !== ASMDisplayState.WAITLIST_AVAILABLE &&
            asmDisplayState !== ASMDisplayState.RESERVABLE;
        return (<div className={styles['cart-item']} data-aid={`Cart-item-row_${listingId}`}>
				<div className={styles['item-flex-container']}>
					<LinkMaybe to={productUrl || '/'} className={cx({ [styles['grayscale']]: isImageGrayScale })} parent={parent}>
						<SimpleImage src={imageUrl} size={112}/>
					</LinkMaybe>
					<div className={styles['cart-item-info']}>
						<div className={styles['cart-item-title-container']}>
							<LinkMaybe to={productUrl || '/'} parent={parent} className={cx(styles['cart-item-title'], { [styles['link-title']]: parent === CartItemParent.CART })}>
								{mainTitle}
							</LinkMaybe>
						</div>
						{this.renderSubtitle()}
						
						{!this.props.isSFLItem ? this.renderSeller() : null}
						{this.renderPriceDetails()}
						{this.renderNbfcOfferInfo()}
						{this.renderMinimumOrderQuantity()}
					</div>
					{!this.props.isSFLItem ? this.renderDeliveryInfo() : null}
				</div>
				<ChildItems items={cartItem.childItems} mainProductListingId={cartItem.listingId} handleRemoveChildItem={this.handleRemoveChildItem}/>
				<CartBuyBack cartItem={this.props.cartItem} handleRemoveChildItem={this.handleRemoveChildItem} handleAddCartItem={this.handleAddCartItem}/>
				<div className={cx(styles['cart-item-actions'], {
            [styles['no-top-margin']]: itemState === CartItemState.COLD_STATE && showQuantityWidget
        })}>
					{showQuantityWidget ? (<div className={styles['quantity-widget-container']}>{this.renderQuantityWidget()}</div>) : null}
					<CartActions {...this.props} className={cx({ [styles['margin-left-cart-actions']]: !showQuantityWidget }, styles['clear-floats'])}/>
				</div>
				{isEGV ? (<div className={styles['egv-sla']}>
						{get(cartItem, ['itemPromiseInfo', 'availablePromises', '0', 'slaMessageConstruct', 'text'])}
					</div>) : null}
			</div>);
    }
}
CartItem.contextTypes = {
    modal: PropTypes.object.isRequired
};
